import { render } from "./removeFilePopup.vue?vue&type=template&id=7255c997&scoped=true"
import script from "./removeFilePopup.vue?vue&type=script&lang=js"
export * from "./removeFilePopup.vue?vue&type=script&lang=js"

import "./removeFilePopup.vue?vue&type=style&index=0&id=7255c997&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7255c997"]])

export default __exports__